<script>
import { Article } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Article',
      addRoute: { name: 'Add Article' },
      verboseName: 'Artykuł',
      verboseNamePlural: 'Artykuły',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'title_en', label: 'tytuł (en)' },
        { prop: 'title_pl', label: 'tytuł (pl)' },
        { prop: 'slug_en', label: 'slug (en)' },
        { prop: 'slug_pl', label: 'slug (pl)' }
      ]
    }
  },
  computed: {
    service() {
      return Article
    }
  }
}
</script>
